import {
  fetchGlobalSearchResults,
  resetGlobalSearchResults,
} from '../routines/globalSearchRoutines';

const initialState = {
  isLoading: false,
  errorMessage: '',
  isError: false,
  searchResults: { pipeline: [], organization: [], account: [], contact: [] },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case fetchGlobalSearchResults.SUCCESS: {
      return {
        ...state,
        searchResults: action.payload,
        isLoading: false,
      };
    }
    case fetchGlobalSearchResults.TRIGGER: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case resetGlobalSearchResults.TRIGGER: {
      return {
        ...initialState,
      };
    }
    case fetchGlobalSearchResults.FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage:
          action.payload?.error.message ||
          action.payload?.error.response?.data?.message,
        isError: true,
      };
    default:
      return state;
  }
};
